import { Modal } from "components/ui/modals/Modal/Modal"
import { ButtonPrimary } from "components/ui/buttons/ButtonPrimary/ButtonPrimary"
import { ButtonWarning } from "components/ui/buttons/ButtonWarning/ButtonWarning"
import { useChangeUserStatus, useUsers } from "hooks/api/user/user.hook"
import { useCallback } from "react"
import { useMessage } from "hooks/message.hook"
import style from "./ChangeStatusModal.module.scss"
import { isAxiosError } from "helpers/utils.helper"

const { modalButtos, question, warning } = style

type Props = {
	isModalOpen: boolean
	userAction: { id: number; newStatus: string }
	setModalOpen: (value: boolean) => void
	record: { name: string }
}

export const ChangeStatusModal = ({ isModalOpen, setModalOpen, userAction, record }: Props) => {
	const { mutate: changeUserStatusMutation } = useChangeUserStatus()
	const { refetch: refetchUsers } = useUsers()
	const { success: successMessage, error: errorMessage } = useMessage()

	const setUserStatus = useCallback(() => {
		changeUserStatusMutation(userAction, {
			onSuccess: () => {
				refetchUsers()
				successMessage(`${record.name} is now ${userAction.newStatus}`)
				setModalOpen(false)
			},
			onError: (e) => {
				if (isAxiosError(e)) errorMessage("Something went wrong, please try again later")
			},
		})
	}, [changeUserStatusMutation, errorMessage, record.name, refetchUsers, setModalOpen, successMessage, userAction])

	return (
		<Modal
			title="Confirm user state change"
			width={600}
			isModalOpen={isModalOpen}
			setModalClose={() => setModalOpen(false)}
		>
			<p className={question}>
				Are you sure you want to <strong>{userAction.newStatus === "active" ? "activate" : "deactivate"}</strong>{" "}
				<strong>{record.name}</strong> ?
			</p>
			<p className={warning}>
				{userAction.newStatus === "active"
					? "Activating this user will restore their access to all application features according to their current role permissions. Are you sure you want to proceed?"
					: userAction.newStatus === "inactive"
						? "Warning: deactivating this user will immediately revoke all access to application features. This action can be reverted. Are you sure you want to proceed?"
						: null}
			</p>
			<div className={modalButtos}>
				<ButtonPrimary onClick={() => setModalOpen(false)}>Cancel</ButtonPrimary>
				<ButtonWarning onClick={() => setUserStatus()}>Confirm</ButtonWarning>
			</div>
		</Modal>
	)
}
